export enum EditorEditItem {
  DESCRIPTION = 'DESCRIPTION',
  NAME = 'NAME',
  INTERNAL_ID = 'INTERNAL_ID',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  FOLDER = 'FOLDER',
  APPLICATION = 'APPLICATION',
  TREATMENT = 'TREATMENT',
  TREATMENT_CATEGORY = 'TREATMENT_CATEGORY',

  DEPARTMENT = 'DEPARTMENT',
  PROCESS_OWNER = 'PROCESS_OWNER',
}
